import { Grid, Typography } from '@material-ui/core'
import { alpha } from '@material-ui/core/styles'
import styled from 'styled-components'
import { Icon } from '../icon/icon'

export const StyledTableWrapper = styled(Grid)`
  margin-top: ${props => props.theme.typography.pxToRem(-70)};
`

export const StyledTitleRow = styled(Grid)`
  background-color: ${props => props.theme.custom.colors.orange};
  border-bottom: 2px solid rgba(213, 66, 12, 0.6);
  margin-top: ${props => props.theme.typography.pxToRem(70)};
`

export const StyledTableTitle = styled(Typography)`
  color: ${props => props.theme.custom.colors.darkRed};
  font-weight: ${props => props.theme.typography.fontWeightMedium};
  font-size: ${props => props.theme.typography.pxToRem(14)};
  padding-left: ${props => props.theme.typography.pxToRem(27)};
  padding-top: ${props => props.theme.typography.pxToRem(20)};
  padding-bottom: ${props => props.theme.typography.pxToRem(16)};

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(16)};
    padding-top: ${props => props.theme.typography.pxToRem(15)};
    padding-bottom: ${props => props.theme.typography.pxToRem(15)};
    padding-left: ${props => props.theme.typography.pxToRem(35)};
  }
`
export const StyledTableRightHeader = styled(Grid)`
  min-width: ${props => props.theme.typography.pxToRem(128)};

  ${props => props.theme.breakpoints.up('sm')} {
    min-width: ${props => props.theme.typography.pxToRem(184)};
  }

  > ${StyledTableTitle} {
    padding-left: ${props => props.theme.typography.pxToRem(27)};

    ${props => props.theme.breakpoints.up('sm')} {
      padding-left: ${props => props.theme.typography.pxToRem(34)};
    }
  }
`

export const StyledTableSubTitle = styled(Typography)`
  font-weight: ${props => props.theme.typography.fontWeightMedium};
  line-height: ${props => props.theme.typography.pxToRem(32)};
  color: ${props => props.theme.palette.text.primary};
  font-size: ${props => props.theme.typography.pxToRem(14)};
  padding-left: ${props => props.theme.typography.pxToRem(27)};
  padding-top: ${props => props.theme.typography.pxToRem(18)};
  padding-bottom: ${props => props.theme.typography.pxToRem(16)};

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(20)};
    padding-top: ${props => props.theme.typography.pxToRem(35)};
    padding-bottom: ${props => props.theme.typography.pxToRem(15)};
    padding-left: ${props => props.theme.typography.pxToRem(34)};
  }
`

export const StyledTableRow = styled(Grid)`
  border-bottom: ${props => props.theme.typography.pxToRem(2)} solid ${alpha('#4d4d4d', 0.2)};
`

export const StyledTableListWrapper = styled.div`
  max-width: ${props => props.theme.typography.pxToRem(700)};
`

export const StyledListItem = styled.li`
  margin-bottom: ${props => props.theme.typography.pxToRem(20)};
`

export const StyledTableRightContainer = styled(Grid)`
  background-color: ${alpha('#f2f2f2', 0.66)};
  min-width: ${props => props.theme.typography.pxToRem(128)};

  ${props => props.theme.breakpoints.up('sm')} {
    min-width: ${props => props.theme.typography.pxToRem(184)};
  }
`

export const StyledTableContent = styled(Grid)`
  height: 100%;
  width: 100%;
`

export const StyledTickIcon = styled(Icon)`
  color: ${props => props.theme.custom.colors.darkRed};
  width: 0.85em;
  height: 0.85em;

  ${props => props.theme.breakpoints.up('sm')} {
    width: 1em;
    height: 1em;
  }
`

export const StyledPrices = styled(Typography)`
  font-weight: 500;
  font-size: ${props => props.theme.typography.pxToRem(14)};
`

export const StyledTableText = styled(Grid)`
  font-size: ${props => props.theme.typography.pxToRem(14)};
  padding-top: ${props => props.theme.typography.pxToRem(15)};
  padding-right: ${props => props.theme.typography.pxToRem(18)};
  padding-bottom: ${props => props.theme.typography.pxToRem(12)};
  padding-left: ${props => props.theme.typography.pxToRem(27)};
  color: ${props => props.theme.palette.text.primary};
  line-height: 1.5;

  ${props => props.theme.breakpoints.up('md')} {
    font-size: ${props => props.theme.typography.pxToRem(17)};
    padding-top: ${props => props.theme.typography.pxToRem(21)};
    padding-right: ${props => props.theme.typography.pxToRem(27)};
    padding-bottom: ${props => props.theme.typography.pxToRem(21)};
    padding-left: ${props => props.theme.typography.pxToRem(34)};
  }

  > p {
    margin: 0;
  }

  > ul {
    ${props => props.theme.breakpoints.up('md')} {
      margin-top: ${props => props.theme.typography.pxToRem(29)};
      margin-bottom: ${props => props.theme.typography.pxToRem(25)};
    }

    li {
      color: ${props => props.theme.palette.text.primary};

      &::before {
        top: 0.4rem;
        color: ${props => props.theme.palette.primary.main};
        ${props => props.theme.breakpoints.up('md')} {
          top: 0.5rem;
        }
      }
    }
  }
`

export const StyledTableDisclaimer = styled(Grid)`
  background-color: rgba(242, 242, 242, 0.5);
  margin-top: ${props => props.theme.typography.pxToRem(20)};
  padding: ${props => props.theme.typography.pxToRem(10)};
  font-size: ${props => props.theme.typography.pxToRem(12)};

  & > a {
    color: ${props => props.theme.palette.secondary.dark};
  }
`
